export const TERRADATA_PT = 'TeraData Persona Type';
export const SAP_PT = 'SAP Persona Type';

export const NSG_LANDSCAPE_TOOLTIP =
    'The target environment or landscape where the Network Security Group will be provisioned, such as DEV, QA, ITE, PreProd, or PROD.';
export const NSG_NAME_TOOLTIP =
    'Enter the name of the Network Security Group (NSG). Use the naming convention defined by your organization. The name must be unique within the applicable scope.';
export const ASG_NAME_TOOLTIP =
    'Enter or select the name of the Application Security Group (ASG) used to logically group application resources for network security rule configuration.';

export const SAP_COMPONENT_CIDR_FIELDS = {
    'sap-app': [
        {
            field: 'databaseCidr',
            label: 'Database CIDR',
            tooltip:
                "Enter the database subnet's IPv4 CIDR range (for example, 10.20.2.0/24). This range is used to define network access rules for database resources.",
        },
        { field: 'managementCidr', label: 'Management CIDR' },
        {
            field: 'sharedFsSubnetCidr',
            label: 'SharedFSSubnetCIDR',
            tooltip:
                'Enter the IPv4 CIDR range of the shared file system subnet (for example, 10.20.3.0/24). This range is used when configuring network access for shared file system resources.',
        },
    ],
    'sap-db': [
        {
            field: 'applicationCidr',
            label: 'Application CIDR',
            tooltip:
                "Enter the application subnet's IPv4 CIDR range (for example, 10.20.1.0/24). This range is used to define network access rules for application resources.",
        },
        { field: 'managementCidr', label: 'Management CIDR' },
    ],
    'sap-mgmt': [],
};

// maps API personaType to its preview section caption; unmatched types fall back to an ungrouped section
export const getPersonaTypeCaption = (personaType) => {
    if (personaType === 'Teradata') return TERRADATA_PT;
    if (personaType === 'SAP') return SAP_PT;
    return '';
};

export default {};
